export const getDefaultUserProfileContext = () => ({
    userProfile: null,
    statistics: null,
    isFetching: false,
    isCurrentUser: null,
    activeTournaments: [],
    pastTournaments: [],
    error: null,
    preview: false,
});
export default getDefaultUserProfileContext;
